import React, { useState } from 'react';
import { Container, Typography, Tabs, Tab, Box } from '@mui/material';
import Billing from './Billing';
import Plans from './Plans';
import UsageDetails from './UsageDetails';
import InvoiceHistory from './InvoiceHistory';

const BillAndPayment = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="lg">
      <Typography mt={3} variant="h4" gutterBottom>Billing and Payment</Typography>
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label="Billing" />
        <Tab label="Plans" />
        <Tab label="Invoice History" />
      </Tabs>
      <Box mt={3}>
        {activeTab === 0 && <Billing />}
        {activeTab === 1 && <Plans />}
        {activeTab === 2 && <InvoiceHistory />}
      </Box>
    </Container>
  );
};

export default BillAndPayment;
